import { Button, Modal } from 'antd';
import PropTypes from 'prop-types';
import React, { useContext, useEffect, useState } from 'react';
import _isEmpty from 'lodash/isEmpty';
import { AttributesContext, SearchPaneResultsContext } from 'common/contexts';

import useAttributeFilters from 'common/customHooks/useAttributeFilters';
import AttributeFilterModal from './components/AttributeFilterModal/AttributeFilterModal';
import RemoveAttributeFilterButton from './components/RemoveAttributeFilterButton';

interface Props {
  active: boolean;
}

const AttributeFilter = ({ active }: Props) => {
  const [initialLoad, setInitialLoad] = useState(true);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [showEmptyResultModal, setShowEmptyResultModal] = useState(false);

  const { attributes } = useContext(AttributesContext);
  const { attributeFilters, setAttributeFiltersInUrl } = useAttributeFilters();

  const { sortedSearchResults } = useContext(SearchPaneResultsContext);

  const handleCloseEmptyResultModal = () => {
    setShowEmptyResultModal(false);
    setShowFilterModal(true);
  };

  useEffect(() => {
    if (!_isEmpty(sortedSearchResults)) {
      // We can do this because initially we load all users into sortedSearchResults before applying any filters
      setInitialLoad(false);
      setShowEmptyResultModal(false);
    } else if (_isEmpty(sortedSearchResults) && !initialLoad) {
      setShowEmptyResultModal(true);
    }
  }, [initialLoad, sortedSearchResults]);

  if (!active) {
    return null;
  }

  return (
    <div
      style={{
        alignItems: 'center',
        display: 'flex',
        flex: 1,
        marginLeft: '10px',
        marginRight: '10px',
      }}
    >
      {attributeFilters.map(filter => (
        <RemoveAttributeFilterButton
          attributeFilters={attributeFilters}
          filter={filter}
          key={`${filter.name}${filter.comparator}${filter.filteredValues}`}
          setAttributeFilters={setAttributeFiltersInUrl}
        />
      ))}
      <Button onClick={() => setShowFilterModal(true)} size="large">
        Filters
      </Button>
      <Modal
        onCancel={handleCloseEmptyResultModal}
        onOk={handleCloseEmptyResultModal}
        open={showEmptyResultModal}
      >
        Sorry, there were no result found. Please update your filters.
      </Modal>
      <AttributeFilterModal
        attributes={attributes}
        filters={attributeFilters}
        isOpen={showFilterModal}
        setFilters={setAttributeFiltersInUrl}
        toggle={() => setShowFilterModal(false)}
      />
    </div>
  );
};

AttributeFilter.propTypes = {
  active: PropTypes.bool.isRequired,
};

export default AttributeFilter;
